import {
  CITY_FILTER,
  TIER_FILTER,
  ROLE_PUBLISHED,
  SET_EXCEL_DATA,
  CANDIDATE_APPLICATION_STATUS,
  COLLEGE_FILTER,
  APPLICATION_DRIVE_LEVEL,
  ROLE_FILTER,
  COURSE_TYPE,
  ROUND,
  DEGREE_DEPARTMENT_FILTER,
  HIRING_LEVEL,
  INTERVIEW_SCHEDULE,
  STUDENT_DETAILS,
  STUDENT_STATUS,
} from './action'
const initialState = {
  cityData: {},
  tierData: {},
  rolesPublishedData: {},
  excelData: {},
  candidateApplicationStatus: {},
  roleData: {},
  collegeData: {},
  applicationDriveLevel: {},
  courseTypeData: {},
  degreeData: {},
  roundData: {},
  hiringLevelData: {},
  interviewData: {},
  studentDetails: {},
  studentStatus: {},
}
export default (state = initialState, action) => {
  switch (action.type) {
    case STUDENT_DETAILS:
      return {
        ...state,
        studentDetails: action.data,
      }
    case STUDENT_STATUS:
      return {
        ...state,
        studentStatus: action.data,
      }
    case INTERVIEW_SCHEDULE:
      return {
        ...state,
        interviewData: action.data,
      }
    case HIRING_LEVEL:
      return {
        ...state,
        hiringLevelData: action.data,
      }
    case DEGREE_DEPARTMENT_FILTER:
      return {
        ...state,
        degreeData: action.data,
      }
    case CITY_FILTER:
      return {
        ...state,
        cityData: action.data,
      }
    case TIER_FILTER:
      return {
        ...state,
        tierData: action.data,
      }
    case COURSE_TYPE:
      return {
        ...state,
        courseTypeData: action.data,
      }
    case ROUND:
      return {
        ...state,
        roundData: action.data,
      }
    case COLLEGE_FILTER:
      return {
        ...state,
        collegeData: action.data,
      }
    case ROLE_FILTER:
      return {
        ...state,
        roleData: action.data,
      }
    case ROLE_PUBLISHED:
      return {
        ...state,
        rolesPublishedData: action.data,
      }
    case CANDIDATE_APPLICATION_STATUS:
      return {
        ...state,
        candidateApplicationStatus: action.data,
      }
    case APPLICATION_DRIVE_LEVEL:
      return {
        ...state,
        applicationDriveLevel: action.data,
      }
    case SET_EXCEL_DATA:
      return {
        ...state,
        excelData: action.data,
      }
    default:
      return state
  }
}
